import { ReferenceText } from '@scale/shared/types/chat';
import { useState } from 'react';
import EditReferenceTextModal from 'react-scale/components/scalers/tasks/ThreadedInteraction/attachments/EditReferenceTextModal';
import { Chip } from '@scale/scaleui';

type ReferenceTextChipProps = {
  name?: string;
  referenceText: ReferenceText;
  setReferenceText: (referenceText: ReferenceText) => void;
  deleteReferenceText: () => void;
  readOnly?: boolean;
  required?: boolean;
  hideUrl?: boolean;
  showReferenceCategory?: boolean;
  editing?: boolean;
  minReferenceTextsLength?: number;
  maxReferenceTextsLength?: number;
};

const ReferenceTextChip = ({
  name,
  referenceText,
  required = false,
  setReferenceText,
  deleteReferenceText,
  hideUrl = false,
  showReferenceCategory = false,
  readOnly,
  minReferenceTextsLength,
  maxReferenceTextsLength,
}: ReferenceTextChipProps) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const label = name || 'Reference Text';
  return (
    <>
      <Chip
        label={label}
        leadingIcon="paperclip"
        className="cursor-pointer"
        onClick={() => {
          setShowModal(true);
        }}
        onDismiss={
          readOnly
            ? undefined
            : () => {
                deleteReferenceText();
              }
        }
      />
      <EditReferenceTextModal
        label={label}
        isOpen={showModal}
        required={required}
        hideUrl={hideUrl}
        showReferenceCategory={showReferenceCategory}
        onClose={() => {
          setShowModal(false);
          if (readOnly) {
            deleteReferenceText();
          }
        }}
        referenceText={referenceText}
        setReferenceText={setReferenceText}
        readOnly={readOnly}
        setIsOpen={setShowModal}
        minReferenceTextsLength={minReferenceTextsLength}
        maxReferenceTextsLength={maxReferenceTextsLength}
      />
    </>
  );
};

export default ReferenceTextChip;
